import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

//redux:
import {
    addVideos,
    selectAllTopBannerVideos,
    selectTopBannerVideosStatus,
} from "../../../../redux/Settings/homePageSlice";

//components:
import TopBannerTable from "./Table";
import {CircularProgress} from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import {ItemsSelectorModal} from "../../../../widgets";
import {mediaItemsListActions} from "../../../../redux/MediaItemsList/mediaItemsListRedux";

const TopBannerCard = () => {
    const {t} = useTranslation();
    //redux:
    //store:
    const topBannerVideosComponents = useSelector(selectAllTopBannerVideos);
    const videosStatus = useSelector(selectTopBannerVideosStatus);
    //actions:
    const dispatch = useDispatch();
    const allMediaItems = useSelector(state => state.mediaItemsList.allMediaItems);
    const getAllMediaItems = () => dispatch(mediaItemsListActions.getAllMediaItems());

    useEffect(() => {
        getAllMediaItems();
    }, []);
    //local state:
    const [showAddVideoModal, setShowAddVideoModal] = useState(false);
    const [videosForAddModal, setVideosForAddModal] = useState([]);
    const [selectedVideos, setSelectedVideos] = useState([]);
    const [debouncer, setDebouncer] = useState();

    const noVideosUploaded = useMemo(() => !allMediaItems?.length, [allMediaItems]);

    useEffect(() => {
        if (allMediaItems?.length && topBannerVideosComponents?.length) {
            const getSelectedVideosByDefault = async () => {
                const idsArray = topBannerVideosComponents.map(component => component.video_id);
                const filtered = allMediaItems.filter(video => !idsArray.includes(video.id));
                const topbannerVideosVideos = topBannerVideosComponents.map(comp => comp.video);

                setVideosForAddModal(filtered);
                setSelectedVideos(topbannerVideosVideos);
            };
            getSelectedVideosByDefault();
        } else {
            setVideosForAddModal(allMediaItems);
        }
    }, [topBannerVideosComponents, allMediaItems]);

    const isLoading = () => videosStatus.type === "loading" || videosStatus.type === "idle";

    const handleItemSelected = (itemsSelected, debounce) => {
        if (itemsSelected?.length) {
            return dispatch(addVideos(itemsSelected.map(video => video.id)));
        }
        return false;
    };

    const getContent = () => {
        if (videosStatus.type === "succeeded") {
            if (topBannerVideosComponents?.length) {
                return <TopBannerTable t={t} videos={topBannerVideosComponents} />;
            }
            return (
                <div className="alert alert-light text-dark w-fit-content">
                    {t("ADMINPANEL.HOMEPAGE.BANNER.EMPTY_MESSAGE")}
                    <Link to={"/adminpanel/upload"}>{t("ADMINPANEL.MENU.UPLOAD")}</Link>
                </div>
            );
        } else if (isLoading()) {
            if (topBannerVideosComponents)
                return (
                    <div className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100">
                        <CircularProgress />
                    </div>
                );
        }
    };

    return (
        <>
            <div className="card card-custom gutter-b shadow">
                <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray justify-content-between">
                    <div className="card-title">{t("ADMINPANEL.HOMEPAGE.BANNER.TITLE")}</div>
                    <div className="card-title my-0">
                        <button
                            type="button"
                            disabled={isLoading() || noVideosUploaded}
                            className="btn btn-primary font-size-base"
                            onClick={() => {
                                setShowAddVideoModal(true);
                            }}
                        >
                            {t("ADMINPANEL.HOMEPAGE.BANNER.ADD_VIDEOS")}
                        </button>
                    </div>
                </div>
                <div className="card-body position-relative min-h-180px">
                    {videosStatus.text ? (
                        <div className={`alert alert-warning font-weight-bold w-fit-content d-flex align-items-center`}>
                            <WarningRoundedIcon color="inherit" className="mr-5" />
                            {videosStatus.text}
                        </div>
                    ) : null}
                    {getContent()}
                </div>
            </div>
            <ItemsSelectorModal
                type="videos"
                showModal={showAddVideoModal}
                setShowModal={setShowAddVideoModal}
                allItems={videosForAddModal}
                selectedItems={selectedVideos}
                handleItemSelected={handleItemSelected}
            />
        </>
    );
};

export default TopBannerCard;
